export default "__VITE_ASSET__BiEEy6wf__"